export const IMPRESSION_TYPE = {
    PRODUCT: 'PRODUCT',
    BANNER: 'BANNER',
};
export const PRODUCT_EVENT_IMPRESSIONS = 'product:impressions';
export const PRODUCT_IMPRESSION_EVENT = 'product_impression';
export const CLICK = 'click';
export const PRODUCT_CARD_CLICKED = 'product_card_clicked';
export const PRODUCT_ADD_TO_CART = 'product_add_to_cart';
export const PRODUCT_ADD_TO_WISHLIST = 'product_add_to_wishlist';
export const PRODUCT_REMOVE_FROM_WISHLIST = 'product_remove_from_wishlist';
export const PRODUCT_SELECT_SHADE = 'product_select_shades';
export const PRODUCT_SELECT_SIZE = 'product_select_sizes';
export const PRODUCT_NOTIFY_ME = 'product_notify_me';
export const PRODUCT_EVENTS = [PRODUCT_IMPRESSION_EVENT, PRODUCT_CARD_CLICKED, PRODUCT_ADD_TO_CART,
    PRODUCT_ADD_TO_WISHLIST, PRODUCT_REMOVE_FROM_WISHLIST, PRODUCT_SELECT_SHADE, PRODUCT_SELECT_SIZE, PRODUCT_NOTIFY_ME];
export const PAGE_LOAD = 'page_load';
export const LOAD = 'load';
